import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map, catchError, throwError as observableThrowError } from 'rxjs';
import { AuthService } from '../../services/authentication/auth.service';
import { ConfigService } from '../../services/config/config.service';

interface ApprovalStatus {
	isQuestionnaireComplete: boolean;
	isCustomerSuccessCallScheduled: boolean;
	isClientApproved: boolean;
	isEULAAccepted:boolean;
	questionnaireQueryString:string;
	scheduleCallQueryString:string;
	isCompanyLinked:boolean;
}

interface OnboardingLinks {
	questionnaireLink: string;
	scheduleCallLink: string;
}

@Injectable({
	providedIn: 'root',
})
export class PendingApprovalService {
	constructor(
		private http: HttpClient,
		private auth: AuthService,
		private config: ConfigService,
	) {}

	fetchApprovalStatus(userId:String): Observable<ApprovalStatus> {
		let httpOptions = {
			headers: new HttpHeaders({ Authorization: 'Bearer ' + this.auth.getToken() }),
		};
		let url = this.config.getBasePath() + '/v2/client/pendingStatus';
		const data = { userId: userId };
		return this.http.post(url, data, httpOptions).pipe(
			map((response: any) => {
				return response;
			}),
			catchError((error: any) => observableThrowError(error.error)),
		);
	}

	fetchOnboardingLinks(): Observable<OnboardingLinks> {
		let httpOptions = {
			headers: new HttpHeaders({ Authorization: 'Bearer ' + this.auth.getToken() }),
		};
		let url = this.config.getBasePath() + '/v2/client/onboardingLinks';
		return this.http.get(url, httpOptions).pipe(
			map((response: any) => {
				return response;
			}),
			catchError((error: any) => observableThrowError(error.error)),
		);
	}

	checkIfOnboardingComplete(userCompanyMapping: any): Observable<{ isOnboardingComplete: boolean }> {
		let mapping = {
			Company_Mapping: userCompanyMapping
		}
		let httpOptions = {
			headers: new HttpHeaders({ Authorization: 'Bearer ' + this.auth.getToken() }),
		};
		let url = this.config.getBasePath() + '/v2/client/checkIfApproved';
		return this.http.post(url, mapping, httpOptions).pipe(
			map((response: any) => {
				return response;
			}),
			catchError((error: any) => observableThrowError(error.error)),
		);
	}

	
}
